module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/239-montenegro-7722dd666f0d6a948759ff6d71584b57.svg";